import { Header } from '../components/Header';
import { PageIntro } from '../components/PageIntro';
import { CasesSection } from '../components/CasesSection';
import { IndustriesSection } from '../components/IndustriesSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
export function CasesPage() {
  return (
    <>
      <Header />
      <PageIntro
        eyebrow="Наши проекты"
        title="Практика на сложных объектах"
        description="Инвентаризация и проверка активов предприятий с крупными объёмами запасов и распределённой инфраструктурой."
      />
      <CasesSection />
      <IndustriesSection />
      <FAQSection />
      <Footer />
    </>
  );
}
